import request from '@/utils/request'

const headers = {
  'Content-Type': 'application/json; charset=UTF-8'
}
// 检查是否登录
export const checkLogin = params => {
  return request.get('/api/tenant/checkLogin', { params })
}
// 获取当前登录用户信息
export const userInfo = params => {
  return request.get('/api/tenant/info', { params })
}
// 获取当前用户所有租户
export const tenantList = params => {
  return request.get('/api/tenant/list', { params })
}
// 退出
export const logout = params => {
  return request.get('/api/tenant/logout', { params })
}
// 获取当前租户订单列表
export const tenantOrderList = params => {
  return request.post('/api/tenant/orderList', params, { headers })
}
// 查询当前租户下角色列表
export const tenantRoleList = params => {
  return request.get('/api/tenant/roleList', { params })
}
// 切换租户
export const setTenant = params => {
  return request.post('/api/tenant/setTenant', params, { headers })
}
// 设置租户工作时间
export const tenantSetWorkTime = params => {
  return request.post('/api/tenant/setWorkTime', params, { headers })
}
// 查询当前租户下人员列表
export const tenantUserList = params => {
  return request.post('/api/tenant/userList', params, { headers })
}
